import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Täpsemat tarneaega küsi &lt;a href="mailto:info\@on24.ee"&gt;klienditeenindusest&lt;/a&gt;.

  <span style="color:#85c1dc;">**FI:**</span>
  Tiedustele toimitusaikaa &lt;a href="mailto:info\@on24.fi?subject=Tuotteen%20<span style="color:#a6d189;">**{toode}**</span>%20toimitusaika%3F"&gt;asiakaspalvelusta&lt;/a&gt;.

  <span style="color:#85c1dc;">**RU:**</span>
  Спроси срок &lt;a href="mailto:info\@ru.on24.ee?subject=<span style="color:#a6d189;">**{toode}**</span>%20срок поставки%3F"&gt;доставки&lt;/a&gt;.
*/
/* @__NO_SIDE_EFFECTS__ */
const m823 = msg(
  mf`Täpsemat tarneaega küsi <a href="mailto:info@on24.ee">klienditeenindusest</a>.`,
  mf`Tiedustele toimitusaikaa <a href="mailto:info@on24.fi?subject=Tuotteen%20${'toode'}%20toimitusaika%3F">asiakaspalvelusta</a>.`,
  mf`Спроси срок <a href="mailto:info@ru.on24.ee?subject=${'toode'}%20срок поставки%3F">доставки</a>.`,
)

export { m823 as 'w.module.delivery_section.ask_more' }